<template>
  <div class="z-1 position-relative">
    <div class="view d-flex flex-column sticky-top">
      <div class="row bg-dark g-0 ">
		<div class="col-12">
			<div class="px-4 d-flex align-items-center justify-content-center justify-content-md-start">
			  	<h1 class="display-1 fs-2 fw-bold p-3 bg-white rounded-2 text-dark ms-0 ms-lg-5">Reach Me</h1>
			</div>
		</div>
		    <div class="content col-12 d-flex flex-column justify-content-between z-1">
		    <div class="text-white fw-lighter d-flex px-0 px-lg-5 py-2 justify-content-center">
				<span class="px-4 text-white">I'm curious to find out what oppurtunities are ahead</span>
		    </div>
        </div>
      </div>
      <div class="row g-0 flex-fill bg-dark py-3 px-0 px-lg-5">
        <div class="col-12 col-lg-6 d-flex align-items-start mb-5 mb-lg-0 px-0 px-lg-5 justify-content-evenly flex-column">
			<div class="contact-form border border-5 rounded-1 shadow flex-fill d-flex flex-column justify-content-center align-items-center w-100 px-4 z-1">
				<form ref="contact" class="w-75">
					<div class="d-flex flex-column align-items-start my-1">
						<label for="name" class="my-1">
							<small class="badge bg-white text-dark shadow">Name</small>
						</label>
						<input name="name" class="custom-input p-2 fs-7 fw-light text-white border rounded-2" type="text" placeholder="your name">
					</div>
					<div class="d-flex flex-column align-items-start my-1">
						<label for="email" class="my-1">
							<small class="badge bg-white text-dark shadow">Email</small>
						</label>
						<input name="email" class="custom-input p-2 fs-7 fw-light text-white border rounded-2" type="email" placeholder="your email">
					</div>
					<div class="d-flex flex-column align-items-start my-1">
						<label for="message" class="my-1">
							<small class="badge bg-white text-dark shadow">Message</small>
						</label>
						<textarea name="message" class="custom-input p-2 fs-7 fw-light text-white border rounded-2 flex-fill w-100" type="text" placeholder="enter your message" rows="5" style="resize: none"></textarea>
					</div>
					<div class="my-3 d-flex justify-content-center">
						<button class="btn border text-white fw-medium mx-1 d-flex align-items-center">
							<span>Clear</span>
							<i class="bi bi-x-circle-fill mx-1"></i>
						</button>
						<button class="btn border text-white fw-medium mx-1 d-flex align-items-center">
							<span>Send</span>
							<i class="bi bi-send mx-1"></i>
						</button>
					</div>
				</form>
			</div>
			<!-- <form ref="contact" class="contact-form border border-5 rounded-1 shadow flex-fill d-flex flex-column justify-content-center align-items-center w-100 px-4 z-1">
				<div class="position-relative my-1 d-flex flex-column align-items-start">
					<label for="name" class="my-1">
						<small class="badge bg-white text-dark shadow">Name</small>
					</label>
					<input name="name" class="custom-input p-2 fs-7 fw-light text-white border rounded-2" type="text" placeholder="your name">
				</div>
				<div class="position-relative my-1 d-flex flex-column align-items-start">
					<label for="email" class="my-1">
						<small class="badge bg-white text-dark shadow">Email</small>
					</label>
					<input name="email" class="custom-input p-2 fs-7 fw-light text-white border rounded-2" type="email" placeholder="your email">
				</div>
				<div class="position-relative my-1 d-flex flex-column align-items-start">
					<label for="message" class="my-1">
						<small class="badge bg-white text-dark shadow">Message</small>
					</label>
					<textarea name="message" class="custom-input p-2 fs-7 fw-light text-white border rounded-2 flex-fill w-100" type="text" placeholder="enter your message" style="resize: none"></textarea>
				</div>
				<div class="my-2 d-flex">
					<button class="btn border text-white fw-medium mx-1 d-flex align-items-center">
						<span>Clear</span>
						<i class="bi bi-x-circle-fill mx-1"></i>
					</button>
					<button class="btn border text-white fw-medium mx-1 d-flex align-items-center">
						<span>Send</span>
						<i class="bi bi-send mx-1"></i>
					</button>
				</div>
			</form> -->
        </div>
        <div class="col-12 col-lg-6 text-white d-flex justify-content-center justify-content-lg-end align-items-center position-relative">
          <div class="bg-secondary rounded-2 shadow px-3 py-2 z-1">
			<div class="d-flex">
				<i class="bi bi-bookmark-fill fs-1 text-white"></i>
			</div>
			<h1 class="my-1">Info</h1>
			<div class="my-2 d-flex flex-column align-items-start">
				<span class	="badge bg-dark my-1 shadow">email</span>
				<div class="d-flex align-items-center bg-dark w-100 rounded-2 px-3 py-2 shadow position-relative">
					<i class="bi bi-envelope-fill fs-5 me-3"></i>
					<span class="mx-auto"><small>rezaarsrvyte@gmail.com</small></span>
				</div>
			</div>
			<div class="my-2 d-flex flex-column align-items-start">
				<span class	="badge bg-dark my-1 shadow">Phone Number</span>
				<div class="d-flex align-items-center bg-dark w-100 rounded-2 px-3 py-2 shadow">
					<i class="bi bi-telephone-fill fs-5 me-3"></i>
					<span class="mx-auto"><small>083 4964 817</small></span>
				</div>
			</div>
			<div class="my-2 d-flex flex-column align-items-start">
				<span class="badge bg-dark my-1 shadow">Location</span>
				<div class="d-flex align-items-center bg-dark w-100 rounded-2 px-3 py-2 shadow">
					<i class="bi bi-radar fs-5 me-3"></i>
					<span class="mx-auto"><small>Strandfontein</small></span>
				</div>
			</div>
            <div class="my-2 d-flex flex-column align-items-start">
				<span class	="badge my-1 bg-dark shadow">Social Media</span>
                <div class="d-flex w-100 justify-content-evenly my-1">
                    <a class="text-white" target="_blank" href="https://www.linkedin.com/in/rezaar-osman-6a4369220">LinkedIn</a>
                    <a class="text-white" target="_blank" href="https://wa.me/+27834964817">WhatsApp</a>
                    <a class="text-white" target="_blank" href="https://github.com/solocyberengineer">Github</a>
                </div>
			</div>
		  </div>
		  <div class="map position-absolute p-5 bg-danger h-100 w-100 z-0 translate-middle-x" :style="{
			'background-image': `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(https://firebasestorage.googleapis.com/v0/b/rezaar-s-portfolio.appspot.com/o/Images%2Fmaps.png?alt=media&token=d32226e5-289f-416d-9f87-2a017d6e5479)`
		  }"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContactView",
  mounted() {
    this.$refs.contact.addEventListener('submit', async (event)=>{
        event.preventDefault();

        const formData = new FormData(event.target);

        console.log(formData);
        let response = await fetch('https://formspree.io/f/xnqekbqp', {
            method: "POST",
            body: formData,
            headers: {
                "Accept": "application/json"
            }
        });

        if( response.status == 200 ){
            alert('Message Sent Successfully');
        } else {
            alert('An Error Occured while trying to send message');
        }

    })
  },
  methods: {
  }
};
</script>
<style scoped>
.custom-input {
	background-color: transparent;
	outline: none;
	border: none;
	width: 100%;
}
.contact-form {
	backdrop-filter: blur(10px);
	background-color: rgba(33,37,41, 0.9);
}
.map {
	transform: translateX(-30%) !important;
	/* box-shadow: inset 0 0 12px 12px rgba(33,37,41, 1); */
	background-position: center;
	background-size: cover;
}
.view {
    height: 100vh;
}

@media screen and (max-width: 992px){
    .view {
        height: auto;
    }
}
</style>